import { filter, mergeMap } from 'rxjs/operators';

import { showModal } from '../../../app/reducers';
import { QualificationStepRequest, QualificationStepResponse } from '../../../domain/qualification';
import { RootState } from '../../../store';
import { RootEpic } from '../../../store/epics';
import { ErrorType } from '../../../store/reducers/common';
import { qualificationSelector } from '../../../store/selectors/qualification/qualification.selector';
import { continueApplicationProcessing } from '../reducers/application';
import { selectCreditTerms } from '../reducers/credit-terms.reducer';
import { nextStep, nextStepFail, NextStepPayload, nextStepSuccess } from '../reducers/next-step';

const nextStepEpic: RootEpic = (action$, state$, { api }) =>
  action$.pipe(
    filter(nextStep.match),
    mergeMap(({ payload }) => {
      return api.qualification
        .nextStep(createQualificationRequest(payload, state$.value))
        .then((response) => {
          return [
            nextStepSuccess(response),
            continueApplicationProcessing({
              redirect: isRedirect(payload, response),
              response,
            }),
            ...(isResume(payload, response) ? [showModal({ type: 'resume-application', context: null })] : []),
          ];
        })
        .catch((error: ErrorType) => {
          return [nextStepFail(error)];
        });
    }),
    mergeMap((action) => action),
  );

const createQualificationRequest = (payload: NextStepPayload, state: RootState): QualificationStepRequest => {
  if (!payload.action) {
    return {};
  } else {
    //todo: collect appropriate data per payload.action to replace saveApplication service/actions/epic

    const { action } = payload;

    switch (action) {
      case 'collect_business_and_applicant_info': {
        const { page } = payload;
        return {
          application: qualificationSelector(state),
          action: shouldAddBusinessAndApplicantInfoAction(page) ? action : undefined,
          meta: { page },
        };
      }

      case 'select_offer': {
        const { selectedOfferId } = selectCreditTerms(state);
        const application = qualificationSelector(state);
        return {
          application: selectedOfferId ? { ...application, selectedOfferId } : application,
          action,
        };
      }

      case 'get_ubos':
      case 'preview_card_order':
      case 'verify_ubos':
      case 'persona':
        return {
          application: qualificationSelector(state),
          action,
        };
    }

    return { action };
  }
};

const isRedirect = (request: NextStepPayload, response: QualificationStepResponse): boolean =>
  request.gotoNextPage || !!response.finalStatus;

const isResume = (request: NextStepPayload, response: QualificationStepResponse): boolean =>
  !!request.resuming && !response.finalStatus && !!response.application;

const shouldAddBusinessAndApplicantInfoAction = (page: NextStepPayload['page']): boolean =>
  page === 'personal_info' || page === 'business_verify';

export { nextStepEpic };
